import {MortgageContract, MortgageMonth} from '../../state/AppState';
import {Lazy} from '../utils/lazy';
import {lazyRnd, rnd} from '../utils/math';
import {Dynamiclist} from './dynamiclist';

export function annuityZeroMonth(contract: MortgageContract): MortgageMonth {
  return {
    month: 0,
    newPrincipalPayment: 0,
    newInterestPayment: 0,
    currentTotalPrincipalPayment: 0,
    currentTotalInterestPayment: 0,
    currentTotalPremiumPayment: 0,
    currentRemainder: contract.mortgagedAmount,
    contract: contract,
    newPremiumPayment: 0
  };
}

export function annuityNextMonth(lastMonth: MortgageMonth, annuity: Lazy<number>): MortgageMonth {

  const newInterestPayment = () => lastMonth.currentRemainder * lastMonth.contract.interestRate / 100 / 12;
  const newPrincipalPayment = () => annuity() - newInterestPayment();
  const currentRemainder = () => lastMonth.currentRemainder - newPrincipalPayment();
  const totalPrincipal = () => lastMonth.currentTotalPrincipalPayment + newPrincipalPayment();
  const totalInterest = () => lastMonth.currentTotalInterestPayment + newInterestPayment();

  return {
    ...lastMonth,
    month: lastMonth.month + 1,
    currentRemainder: lazyRnd(currentRemainder)(),
    newPrincipalPayment: lazyRnd(newPrincipalPayment)(),
    newInterestPayment: lazyRnd(newInterestPayment)(),
    currentTotalPrincipalPayment: lazyRnd(totalPrincipal)(),
    currentTotalInterestPayment: lazyRnd(totalInterest)(),
  };
}

export function determineMonthlyAnnuityForContract(lastMonth: MortgageMonth): number {
  const contract = lastMonth.contract;
  return determineMonthlyAnnuity(lastMonth.currentRemainder, contract.interestRate, contract.durationMonths - lastMonth.month);
}

function determineMonthlyAnnuity(mortagedAmount: number, yearlyInterest: number, months: number): number {
  const fractionalMonthlyInterest = yearlyInterest / 12.0 / 100.0;
  return rnd(fractionalMonthlyInterest / (1 - Math.pow(1 + fractionalMonthlyInterest, -months)) * mortagedAmount);
}

export function calculateChain(lastMonth: MortgageMonth, duration: number) : Dynamiclist<MortgageMonth> {
    return () => {
      if (duration < 0) {
        return null;
      } else {
        return {
          head: () => lastMonth,
          tail: (head: MortgageMonth = lastMonth) => {
            const annuity = () => determineMonthlyAnnuityForContract(head)
            return calculateChain(annuityNextMonth(head, annuity), duration - 1)()
          }
        };
      }
    };
}
